// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&family=Cinzel+Decorative:wght@700&family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.horse-stable-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(2, 3, 8, 0.6);
  pointer-events: none;
  font-family: "Cormorant Garamond", "Palatino Linotype", serif;
}

.horse-stable-shell {
  pointer-events: auto;
  width: clamp(520px, 54vw, 780px);
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, rgba(12, 22, 27, 0.97), rgba(5, 7, 8, 0.99));
  border: 1px solid rgba(110, 88, 48, 0.4);
  border-radius: 6px;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.6);
}

.horse-stable-header {
  padding: 18px 28px 14px;
  text-align: center;
  border-bottom: 1px solid rgba(110, 88, 48, 0.4);
  flex-shrink: 0;
}

.horse-stable-header__brand {
  font-family: "Cinzel", serif;
  font-size: 0.75rem;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: #676b6c;
}

.horse-stable-header__title {
  font-family: "Cinzel Decorative", "Cinzel", serif;
  font-size: 1.7rem;
  color: var(--gold-light);
  margin: 4px 0 2px;
}

.horse-stable-header__tagline {
  font-size: 1rem;
  color: #a9a69e;
}

.horse-stable-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 24px;
}

.horse-stable-sell {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 14px;
}

.horse-stable-sell__button {
  padding: 8px 16px;
  background: transparent;
  border: 1px solid rgba(110, 88, 48, 0.4);
  border-radius: 4px;
  color: #e7e1d7;
  font-family: "Cinzel", serif;
  cursor: pointer;
}
.horse-stable-sell__button:hover {
  border-color: var(--gold-main);
  color: var(--gold-light);
}

.horse-stable-sell-confirm {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  margin-bottom: 14px;
  background: rgba(182, 107, 97, 0.1);
  border: 1px solid rgba(182, 107, 97, 0.4);
  border-radius: 4px;
}

.horse-stable-sell-confirm__text {
  color: #b66b61;
  font-family: "Cinzel", serif;
  font-size: 0.95rem;
}

.horse-stable-sell-confirm__actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.horse-stable-sell-confirm__confirm,
.horse-stable-sell-confirm__cancel {
  padding: 8px 16px;
  background: transparent;
  border: 1px solid rgba(110, 88, 48, 0.4);
  border-radius: 4px;
  color: #e7e1d7;
  font-family: "Cinzel", serif;
  cursor: pointer;
}
.horse-stable-sell-confirm__confirm:hover,
.horse-stable-sell-confirm__cancel:hover {
  border-color: var(--gold-main);
  color: var(--gold-light);
}

.horse-shop-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.horse-shop-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 12px 10px 14px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(110, 88, 48, 0.4);
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  color: #e7e1d7;
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}
.horse-shop-card:hover:not(:disabled) {
  background: rgba(210, 168, 74, 0.12);
  border-color: var(--gold-main);
  transform: translateY(-2px);
}
.horse-shop-card:disabled {
  cursor: default;
  opacity: 0.5;
}

.horse-shop-card__portrait-frame {
  width: 100%;
  aspect-ratio: 1/1;
  border-radius: 4px;
  overflow: hidden;
  background: radial-gradient(circle at 50% 35%, rgba(210, 168, 74, 0.14), transparent 70%), rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(110, 88, 48, 0.4);
}

.horse-shop-card__portrait {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.horse-shop-card__name {
  font-family: "Cinzel", serif;
  font-size: 1rem;
  color: #e7e1d7;
}

.horse-shop-card__price {
  font-size: 0.85rem;
  color: var(--gold-light);
}

.horse-shop-card__lock {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 0.9rem;
}

.horse-manage {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.horse-manage__portrait-frame {
  width: 100%;
  height: clamp(160px, 26vh, 240px);
  border-radius: 6px;
  overflow: hidden;
  background: radial-gradient(circle at 50% 30%, rgba(210, 168, 74, 0.16), transparent 70%), rgba(0, 0, 0, 0.4);
  border: 1px solid rgba(110, 88, 48, 0.4);
}

.horse-manage__portrait {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 30%;
}

.horse-manage__info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.horse-manage__name-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}

.horse-manage__name {
  font-family: "Cinzel Decorative", "Cinzel", serif;
  font-size: 1.3rem;
  color: var(--gold-light);
}

.horse-manage__state {
  font-family: "Cinzel", serif;
  font-size: 0.8rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 3px 10px;
  border-radius: 999px;
  border: 1px solid rgba(110, 88, 48, 0.4);
  color: #a9a69e;
}
.horse-manage__state--summoned {
  color: #8fab65;
  border-color: rgba(143, 171, 101, 0.4);
}

.horse-manage__hunger {
  display: flex;
  align-items: center;
  gap: 10px;
}

.horse-manage__hunger-bar {
  flex: 1;
  height: 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(110, 88, 48, 0.4);
  overflow: hidden;
}

.horse-manage__hunger-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--gold-main), var(--gold-light));
  transition: width 0.3s ease;
}
.horse-manage__hunger-fill--low {
  background: linear-gradient(90deg, #b66b61, #d68f83);
}

.horse-manage__hunger-label {
  flex-shrink: 0;
  font-size: 0.85rem;
  color: #a9a69e;
  min-width: 4.5em;
  text-align: right;
}

.horse-manage__warning {
  font-size: 0.85rem;
  color: #b66b61;
  margin: 0;
}

.horse-manage__actions {
  display: flex;
  gap: 10px;
}

.horse-manage__action {
  flex: 1;
  padding: 10px 16px;
  background: transparent;
  border: 1px solid rgba(110, 88, 48, 0.4);
  border-radius: 4px;
  color: #e7e1d7;
  font-family: "Cinzel", serif;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.horse-manage__action:hover:not(:disabled) {
  border-color: var(--gold-main);
  color: var(--gold-light);
}
.horse-manage__action:disabled {
  cursor: default;
  opacity: 0.45;
}

.horse-manage__action--primary {
  background: rgba(210, 168, 74, 0.12);
  border-color: var(--gold-main);
  color: var(--gold-light);
}
.horse-manage__action--primary:hover:not(:disabled) {
  background: rgba(210, 168, 74, 0.2);
}

.horse-manage__sell-row {
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
  border-top: 1px solid rgba(110, 88, 48, 0.4);
}

.horse-stable-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 14px 24px;
  border-top: 1px solid rgba(110, 88, 48, 0.4);
  flex-shrink: 0;
}

.horse-stable-close-btn {
  padding: 8px 20px;
  background: transparent;
  border: 1px solid rgba(110, 88, 48, 0.4);
  border-radius: 4px;
  color: #e7e1d7;
  font-family: "Cinzel", serif;
  cursor: pointer;
}
.horse-stable-close-btn:hover {
  border-color: var(--gold-main);
  color: var(--gold-light);
}`, "",{"version":3,"sources":["webpack://./src/components/HorseStable/styles.scss"],"names":[],"mappings":"AAuBA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,oBAAA;EACA,6DAXU;AAVZ;;AAwBA;EACE,oBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gFACE;EACF,wCAAA;EACA,kBAAA;EACA,0CAAA;AAtBF;;AAyBA;EACE,uBAAA;EACA,kBAAA;EACA,+CAAA;EACA,cAAA;AAtBF;;AAwBA;EACE,4BApCa;EAqCb,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cA9CW;AAyBb;;AAuBA;EACE,iDA5Ca;EA6Cb,iBAAA;EACA,wBAzDW;EA0DX,iBAAA;AApBF;;AAsBA;EACE,eAAA;EACA,cAzDe;AAsCjB;;AAsBA;EACE,OAAA;EACA,gBAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAnBF;;AAqBA;EACE,iBAAA;EACA,uBAAA;EACA,wCAAA;EACA,kBAAA;EACA,cA9EU;EA+EV,4BAvEa;EAwEb,eAAA;AAlBF;AAoBE;EACE,8BAxFQ;EAyFR,wBAxFS;AAsEb;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,mCAAA;EACA,yCAAA;EACA,kBAAA;AAnBF;;AAqBA;EACE,cA/FO;EAgGP,4BA7Fa;EA8Fb,kBAAA;AAlBF;;AAoBA;EACE,aAAA;EACA,QAAA;EACA,cAAA;AAjBF;;AAmBA;;EAEE,iBAAA;EACA,uBAAA;EACA,wCAAA;EACA,kBAAA;EACA,cAnHU;EAoHV,4BA5Ga;EA6Gb,eAAA;AAhBF;AAkBE;;EACE,8BA7HQ;EA8HR,wBA7HS;AA8Gb;;AAqBA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,qCAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAjJU;EAkJV,gFAAA;AAlBF;AAoBE;EACE,oCAvJS;EAwJT,8BA3JQ;EA4JR,2BAAA;AAlBJ;AAqBE;EACE,eAAA;EACA,YAAA;AAnBJ;;AAuBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8GAAA;EACA,wCAAA;AApBF;;AAuBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AApBF;;AAuBA;EACE,4BAxKa;EAyKb,eAAA;EACA,cAlLU;AA8JZ;;AAuBA;EACE,kBAAA;EACA,wBA3LW;AAuKb;;AAuBA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;AApBF;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,6GAAA;EACA,wCAAA;AAtBF;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;AAtBF;;AAyBA;EACE,iDAhOa;EAiOb,iBAAA;EACA,wBA7OW;AAuNb;;AAyBA;EACE,4BArOa;EAsOb,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;EACA,wCAAA;EACA,cAnPe;AA6NjB;AAwBE;EACE,cAnPM;EAoPN,sCAAA;AAtBJ;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAvBF;;AA0BA;EACE,OAAA;EACA,YAAA;EACA,oBAAA;EACA,qCAAA;EACA,wCAAA;EACA,gBAAA;AAvBF;;AA0BA;EACE,YAAA;EACA,uEAAA;EACA,2BAAA;AAvBF;AAyBE;EACE,oDAAA;AAvBJ;;AA2BA;EACE,cAAA;EACA,kBAAA;EACA,cAvRe;EAwRf,gBAAA;EACA,iBAAA;AAxBF;;AA2BA;EACE,kBAAA;EACA,cA1RO;EA2RP,SAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,SAAA;AAxBF;;AA2BA;EACE,OAAA;EACA,kBAAA;EACA,uBAAA;EACA,wCAAA;EACA,kBAAA;EACA,cA9SU;EA+SV,4BAvSa;EAwSb,eAAA;EACA,0DAAA;AAxBF;AA0BE;EACE,8BAzTQ;EA0TR,wBAzTS;AAiSb;AA2BE;EACE,eAAA;EACA,aAAA;AAzBJ;;AA6BA;EACE,oCAjUW;EAkUX,8BArUU;EAsUV,wBArUW;AA2Sb;AA4BE;EACE,mCAAA;AA1BJ;;AA8BA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,4CAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,4CAAA;EACA,cAAA;AA3BF;;AA8BA;EACE,iBAAA;EACA,uBAAA;EACA,wCAAA;EACA,kBAAA;EACA,cA7VU;EA8VV,4BAtVa;EAuVb,eAAA;AA3BF;AA6BE;EACE,8BAvWQ;EAwWR,wBAvWS;AA4Ub","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&family=Cinzel+Decorative:wght@700&family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400&display=swap');\r\n\r\n// Same palette family / structure as features/craftMenu/styles.scss (see\r\n// that file's own comment) - --gold-* are the palette-switchable custom\r\n// properties, so this panel re-themes along with every other one.\r\n$bg-black: #050708;\r\n\r\n$gold-main: var(--gold-main);\r\n$gold-light: var(--gold-light);\r\n$border-light: rgba(110, 88, 48, 0.4);\r\n$gold-faint: rgba(210, 168, 74, 0.12);\r\n\r\n$text-main: #e7e1d7;\r\n$text-secondary: #a9a69e;\r\n$text-muted: #676b6c;\r\n\r\n$success: #8fab65;\r\n$danger: #b66b61;\r\n\r\n$font-display: 'Cinzel Decorative', 'Cinzel', serif;\r\n$font-heading: 'Cinzel', serif;\r\n$font-body: 'Cormorant Garamond', 'Palatino Linotype', serif;\r\n\r\n.horse-stable-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 9999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: rgba(2, 3, 8, 0.6);\r\n  pointer-events: none;\r\n  font-family: $font-body;\r\n}\r\n\r\n.horse-stable-shell {\r\n  pointer-events: auto;\r\n  width: clamp(520px, 54vw, 780px);\r\n  max-height: 80vh;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background:\r\n    linear-gradient(180deg, rgba(12, 22, 27, 0.97), rgba(5, 7, 8, 0.99));\r\n  border: 1px solid $border-light;\r\n  border-radius: 6px;\r\n  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.horse-stable-header {\r\n  padding: 18px 28px 14px;\r\n  text-align: center;\r\n  border-bottom: 1px solid $border-light;\r\n  flex-shrink: 0;\r\n}\r\n.horse-stable-header__brand {\r\n  font-family: $font-heading;\r\n  font-size: 0.75rem;\r\n  letter-spacing: 0.25em;\r\n  text-transform: uppercase;\r\n  color: $text-muted;\r\n}\r\n.horse-stable-header__title {\r\n  font-family: $font-display;\r\n  font-size: 1.7rem;\r\n  color: $gold-light;\r\n  margin: 4px 0 2px;\r\n}\r\n.horse-stable-header__tagline {\r\n  font-size: 1rem;\r\n  color: $text-secondary;\r\n}\r\n\r\n.horse-stable-body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 16px 24px;\r\n}\r\n\r\n.horse-stable-sell {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  margin-bottom: 14px;\r\n}\r\n.horse-stable-sell__button {\r\n  padding: 8px 16px;\r\n  background: transparent;\r\n  border: 1px solid $border-light;\r\n  border-radius: 4px;\r\n  color: $text-main;\r\n  font-family: $font-heading;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    border-color: $gold-main;\r\n    color: $gold-light;\r\n  }\r\n}\r\n\r\n.horse-stable-sell-confirm {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 10px 14px;\r\n  margin-bottom: 14px;\r\n  background: rgba(182, 107, 97, 0.1);\r\n  border: 1px solid rgba(182, 107, 97, 0.4);\r\n  border-radius: 4px;\r\n}\r\n.horse-stable-sell-confirm__text {\r\n  color: $danger;\r\n  font-family: $font-heading;\r\n  font-size: 0.95rem;\r\n}\r\n.horse-stable-sell-confirm__actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-shrink: 0;\r\n}\r\n.horse-stable-sell-confirm__confirm,\r\n.horse-stable-sell-confirm__cancel {\r\n  padding: 8px 16px;\r\n  background: transparent;\r\n  border: 1px solid $border-light;\r\n  border-radius: 4px;\r\n  color: $text-main;\r\n  font-family: $font-heading;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    border-color: $gold-main;\r\n    color: $gold-light;\r\n  }\r\n}\r\n\r\n// --- Shop screen (no horse owned) ---------------------------------------\r\n\r\n.horse-shop-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 12px;\r\n}\r\n\r\n.horse-shop-card {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 12px 10px 14px;\r\n  background: rgba(255, 255, 255, 0.02);\r\n  border: 1px solid $border-light;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  color: $text-main;\r\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;\r\n\r\n  &:hover:not(:disabled) {\r\n    background: $gold-faint;\r\n    border-color: $gold-main;\r\n    transform: translateY(-2px);\r\n  }\r\n\r\n  &:disabled {\r\n    cursor: default;\r\n    opacity: 0.5;\r\n  }\r\n}\r\n\r\n.horse-shop-card__portrait-frame {\r\n  width: 100%;\r\n  aspect-ratio: 1 / 1;\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  background: radial-gradient(circle at 50% 35%, rgba(210, 168, 74, 0.14), transparent 70%), rgba(0, 0, 0, 0.35);\r\n  border: 1px solid $border-light;\r\n}\r\n\r\n.horse-shop-card__portrait {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.horse-shop-card__name {\r\n  font-family: $font-heading;\r\n  font-size: 1rem;\r\n  color: $text-main;\r\n}\r\n\r\n.horse-shop-card__price {\r\n  font-size: 0.85rem;\r\n  color: $gold-light;\r\n}\r\n\r\n.horse-shop-card__lock {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n// --- Management screen (owned horse) -------------------------------------\r\n\r\n.horse-manage {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n}\r\n\r\n.horse-manage__portrait-frame {\r\n  width: 100%;\r\n  height: clamp(160px, 26vh, 240px);\r\n  border-radius: 6px;\r\n  overflow: hidden;\r\n  background: radial-gradient(circle at 50% 30%, rgba(210, 168, 74, 0.16), transparent 70%), rgba(0, 0, 0, 0.4);\r\n  border: 1px solid $border-light;\r\n}\r\n\r\n.horse-manage__portrait {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  object-position: center 30%;\r\n}\r\n\r\n.horse-manage__info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.horse-manage__name-row {\r\n  display: flex;\r\n  align-items: baseline;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n}\r\n\r\n.horse-manage__name {\r\n  font-family: $font-display;\r\n  font-size: 1.3rem;\r\n  color: $gold-light;\r\n}\r\n\r\n.horse-manage__state {\r\n  font-family: $font-heading;\r\n  font-size: 0.8rem;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n  padding: 3px 10px;\r\n  border-radius: 999px;\r\n  border: 1px solid $border-light;\r\n  color: $text-secondary;\r\n\r\n  &--summoned {\r\n    color: $success;\r\n    border-color: rgba(143, 171, 101, 0.4);\r\n  }\r\n}\r\n\r\n.horse-manage__hunger {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.horse-manage__hunger-bar {\r\n  flex: 1;\r\n  height: 10px;\r\n  border-radius: 999px;\r\n  background: rgba(255, 255, 255, 0.06);\r\n  border: 1px solid $border-light;\r\n  overflow: hidden;\r\n}\r\n\r\n.horse-manage__hunger-fill {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, $gold-main, $gold-light);\r\n  transition: width 0.3s ease;\r\n\r\n  &--low {\r\n    background: linear-gradient(90deg, $danger, #d68f83);\r\n  }\r\n}\r\n\r\n.horse-manage__hunger-label {\r\n  flex-shrink: 0;\r\n  font-size: 0.85rem;\r\n  color: $text-secondary;\r\n  min-width: 4.5em;\r\n  text-align: right;\r\n}\r\n\r\n.horse-manage__warning {\r\n  font-size: 0.85rem;\r\n  color: $danger;\r\n  margin: 0;\r\n}\r\n\r\n.horse-manage__actions {\r\n  display: flex;\r\n  gap: 10px;\r\n}\r\n\r\n.horse-manage__action {\r\n  flex: 1;\r\n  padding: 10px 16px;\r\n  background: transparent;\r\n  border: 1px solid $border-light;\r\n  border-radius: 4px;\r\n  color: $text-main;\r\n  font-family: $font-heading;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease, border-color 0.15s ease;\r\n\r\n  &:hover:not(:disabled) {\r\n    border-color: $gold-main;\r\n    color: $gold-light;\r\n  }\r\n\r\n  &:disabled {\r\n    cursor: default;\r\n    opacity: 0.45;\r\n  }\r\n}\r\n\r\n.horse-manage__action--primary {\r\n  background: $gold-faint;\r\n  border-color: $gold-main;\r\n  color: $gold-light;\r\n\r\n  &:hover:not(:disabled) {\r\n    background: rgba(210, 168, 74, 0.2);\r\n  }\r\n}\r\n\r\n.horse-manage__sell-row {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding-top: 8px;\r\n  border-top: 1px solid $border-light;\r\n}\r\n\r\n.horse-stable-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  padding: 14px 24px;\r\n  border-top: 1px solid $border-light;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.horse-stable-close-btn {\r\n  padding: 8px 20px;\r\n  background: transparent;\r\n  border: 1px solid $border-light;\r\n  border-radius: 4px;\r\n  color: $text-main;\r\n  font-family: $font-heading;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    border-color: $gold-main;\r\n    color: $gold-light;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
